import _objectWithoutProperties from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";
import _taggedTemplateLiteral from "/codebuild/output/src875296868/src/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
const _excluded = ["children", "text", "to"];
var _templateObject, _templateObject2;
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import { basePropTypes, handleProps } from './utils';
import propsToCss from '../utils/propsToCss';
const StyledLink = styled(Link)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  cursor: pointer;\n  ", "\n"])), props => propsToCss(props));
const StyledAnchor = styled.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  ", "\n"])), props => propsToCss(props));
const LinkButton = _ref => {
  let {
      children,
      text,
      to
    } = _ref,
    rest = _objectWithoutProperties(_ref, _excluded);
  if (!to) {
    return null;
  }
  if (to.startsWith('http')) {
    return /*#__PURE__*/React.createElement(StyledAnchor, _extends({}, handleProps(rest), {
      href: to
    }), children || text);
  }
  return /*#__PURE__*/React.createElement(StyledLink, _extends({}, handleProps(rest), {
    to: to
  }), children || text);
};
LinkButton.propTypes = basePropTypes;
export default LinkButton;